import type { WarningKeyEnum, WarningKindEnum } from './ticket-selection-warning-report';

export type Warning = {
    kind: WarningKindEnum;
    
    // Object targeting fields
    eventDateId?: number;
    packageId?: number;
    priceId?: number;
    priceGroupId?: number;
    priceName?: string;

    /** Type key and also translation key */
    key: WarningKeyEnum;

    disabled?: boolean;
    missingQty?: number;
    qtyToRemove?: number;
    qtyNeeded?: number;
    maximumQty?: number;
    multipleOfNeeded?: number;
    creditCardName?: string;
    cardName?: string;
    expiredTicketIds?: number[];
    atLeastOneTicketInCart?: boolean;
    promoCodePriceGroupName?: string;
}